import {Color} from "three";

export const MATERIAL_PROPS_DB = [
    /*  {
          materialName: 'WallMat',
          emmissiveIntensity: .81, //Emissive intensity
          emmisiveColor: new Color(0xFFFFFF),
          aOIntensity: 0.58, //Ambient occlusion
          envMapIntensity: .25
      },

      {
          materialName: 'CeilingMat',
          emmissiveIntensity: .4, //Emissive intensity
          emmisiveColor: new Color(0xFFFFFF),
          aOIntensity: 0.35, //Ambient occlusion
      },

      {
          materialName: 'CeilingMetalBars',
          // emmissiveIntensity:1, //Emissive intensity
          // emmisiveColor:new Color(0x000000),
          aOIntensity: .5, //Ambient occlusion
      },

      {
          materialName: 'PillarMat',
          emmissiveIntensity: .7, //Emissive intensity
          emmisiveColor: new Color(0xFFFFFF),
          aOIntensity: .5, //Ambient occlusion
      },

      {
          materialName: 'LampEmmisiveMat',
          emmissiveIntensity: .5, //Emissive intensity
          emmisiveColor: new Color(0xD9B37C),
          aOIntensity: 1, //Ambient occlusion
      },


      {
          materialName: 'FloorMat',
          /!* emmissiveIntensity:.5, //Emissive intensity
           emmisiveColor:new Color(0xD9B37C),*!/
          aOIntensity: .64, //Ambient occlusion
      },

      {
          materialName: 'WindowDoorMat',
          /!* emmissiveIntensity:.5, //Emissive intensity
           emmisiveColor:new Color(0xD9B37C),*!/
          aOIntensity: .1, //Ambient occlusion
      },

      {
          materialName: 'LampWireMat',
          emmissiveIntensity: 1.5, //Emissive intensity
          emmisiveColor: new Color(0xFFFFFF),
          // aOIntensity:.1, //Ambient occlusion
      },

      {
          materialName: 'PlinthCatalogMat',
          /!*  emmissiveIntensity:null,
            emmisiveColor:null,*!/
          aOIntensity: 0.1, //Ambient occlusion
      },

      {
          materialName: 'UVT43Mat',
          /!*  emmissiveIntensity:null,
            emmisiveColor:null,*!/
          aOIntensity: 0.25, //Ambient occlusion
      },

      {
          materialName: 'DomeFloorMat',
          /!*  emmissiveIntensity:null,
            emmisiveColor:null,*!/
          aOIntensity: 0.6, //Ambient occlusion
      },

      {
          materialName: 'DoorOnlyMat',
          /!*  emmissiveIntensity:null,
            emmisiveColor:null,*!/
          envMapIntensity: 1.6,
          aOIntensity: 1, //Ambient occlusion
      },*/

    {
        materialName: 'FloorMat',

        aOIntensity: .511, //Ambient occlusion
        envMapIntensity: 0.58,
        roughness: .5,
        useMapAsLightMap:'Y',

    },


    {
        materialName:"WallsMat",
        aOIntensity:0.9055346771438333,
        emmisiveColor:
            new Color( 0, 0, 0 ),
        emmissiveIntensity:1,
        envMapIntensity:5.403655620088829,
        lightMapIntensity:3.8930645712333445,
        roughness:0.5,


        useMapAsLightMap:'Y',

    },
    {
        materialName:"CeilingMat",
        aOIntensity:0.5775538093611207,
        emmisiveColor:
            new Color( 0, 0, 0 ),
        emmissiveIntensity:1.0172531602323198,
        envMapIntensity:6.092415442432525,
        lightMapIntensity:2.1438332763922103,
        roughness:0.5,

        useMapAsLightMap:'Y',
        // toneMapped:'N',
    },
    {
        materialName: 'DoorFrameMat',
       /* emmissiveIntensity: .4, //Emissive intensity
        emmisiveColor: new Color(0xFFFFFF),*/
        aOIntensity: 0.51, //Ambient occlusion
        envMapIntensity: 2,
        useMapAsLightMap:'Y',
        roughness: .08,
    },
    {
        materialName: 'UVT01Mat',

       envMapIntensity:1.9598565083703452,
        toneMapped:'N',

    },

    {
        materialName: 'UVT02Mat',

        envMapIntensity:1.1180389477280492,
        toneMapped:'N',

    },
    {
        materialName: 'UVT03Mat',

        envMapIntensity:1.3476255551759482,
        toneMapped:'N',

    },
    {
        materialName: 'UVT04Mat',

        envMapIntensity:1.806798770071746,
        toneMapped:'N',

    },

    {
        materialName: 'UVT05Mat',

        envMapIntensity:1.7302699009224463,
        toneMapped:'N',

    },

    {
        materialName: 'UVT06Mat',

        envMapIntensity:1.7302699009224463,
        toneMapped:'N',

    },

    {
        materialName: 'UVT07Mat',

        envMapIntensity:1.7302699009224463,
        toneMapped:'N',
        // useMapAsLightMap:'Y',
        // roughness: .08,
    },

    {
        materialName: 'UVT08Mat',

        envMapIntensity:1.7302699009224463,
        toneMapped:'N',

    },
    {
        materialName: 'UVT09Mat',

        envMapIntensity:1.0415100785787494,
        toneMapped:'N',

    },
    {
        materialName: 'UVT10Mat',

        envMapIntensity:1.8833276392210454,
        toneMapped:'N',

    },

    {
        materialName: 'MountMat',

        // envMapIntensity: 2.2,
        toneMapped:'N',

    },
    {
        materialName:"WhiteFrame",
        aOIntensity:1,
        /*emmisiveColor:
            new Color( 0, 0, 0 ),
        emmissiveIntensity:1,*/
        envMapIntensity:3.2608472839084386,
        lightMapIntensity:1,
        //roughness:0.5,
        toneMapped:'Y',
    },


]
